import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";
import IconArrow from "../../../../components/icons/IconArrow.tsx";

export default function OfflineArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Vi anbefaler, at du prøver følgende, når dit internet ikke virker:
                        </h2>
                        <ul className="list list--number">
                            <li>
                                <p>
                                    Tjek <a href="https://drift.hiper.dk" target={"_blank"}>vores driftstatus</a>.
                                </p>
                                <ul className="list list--bullet">
                                    <li><p>
                                        Måske er der driftsforstyrrelser i dit område.
                                    </p></li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Tjek at kablerne sidder korrekt i din router.
                                </p>
                                <ul className="list list--bullet">
                                    <li><p>
                                        Nogle gange kommer kablerne til at sidde løst i enten routeren eller stikket i væggen.
                                    </p></li>
                                    <li><p>
                                        Globus-lampen på routeren skal lyse grønt &ndash; hvis den ikke lyser grønt, er det ofte fordi kablerne sidder forkert.
                                    </p></li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Tjek at din router er tændt.
                                </p>
                                <ul className="list list--bullet">
                                    <li><p>
                                        Knappen <strong>POWER</strong> på bagsiden af routeren skal være trykket ind.
                                    </p></li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Genstart din router.
                                </p>
                                <ul className="list list--bullet">
                                    <li><p>
                                        Det hjælper ofte at slukke og tænde routeren igen.
                                    </p></li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Bruger du din egen router?
                                    Så anbefaler vi, at du også tester ovenstående på din Hiper-router.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <h2>
                        Vælg dit produkt for at finde yderligere hjælp
                    </h2>
                    <div className={'button-container'}>
                        <a href={'#fiber'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har fibernet
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#coax'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har internet via kabel-tv-stikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#dsl'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har internet via telefonstikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#not-sure'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg ved ikke, hvilket produkt jeg har
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>Fibernet</h3>
                        <ul className="list list--bullet">
                            <li>
                                <p><strong>Tjek at netværkskablet sidder korrekt i din router og fiberboks</strong></p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            Kablet skal sidde i routerens blå WAN-port og i fiberboksens aktive LAN-port.
                                        </p>
                                        <p>
                                            Du kan se den aktive LAN-port i Mit Hiper under &ldquo;Mit Abonnement&rdquo;.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p><strong>Tjek at strømforsyningen sidder i fiberboksen og stikkontakten</strong></p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>
                                            Har du ikke en strømforsyning til din fiberboks, må du gerne kontakte os med det samme.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p><strong>Nulstil din router</strong></p>
                                <ul className="list list--bullet list--image">
                                    <li>
                                        <p>
                                            Tryk en spids genstand mod reset-knappen bag på routeren i 20 sekunder, mens routeren er tændt.
                                        </p>
                                        <p>
                                            Når du nulstiller routeren, bliver eventuelle ændringer som wifi-kode, -navn mm. også nulstillet.
                                            Det betyder, at du skal lave ændringerne igen, efter du har nulstillet.
                                        </p>
                                    </li>
                                    <img
                                        className={'max-height no-br'}
                                        src={imageMap.help.equipment.zyxelReset}
                                        alt={'Grafik som illustrerer hvor reset-knappen sidder på en Zyxel router.'}
                                    />
                                </ul>
                            </li>
                            <li>
                                <p><strong>Nulstil din fiberboks</strong></p>
                                <ul className="list list--number">
                                    <li><p>
                                        På undersiden af fiberboksen er der et lille hul, hvor der står &ldquo;reset&rdquo;.
                                    </p></li>
                                    <li><p>
                                        Tryk en spids genstand mod reset-hullet i 20 sekunder, mens fiberboksen er tændt.
                                    </p></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'coax'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>Internet via kabel-tv-stikket</h3>
                        <ul className="list list--bullet">
                            <li>
                                <p><strong>Genstart din router</strong></p>
                                <ul className="list list--number">
                                    <li><p>
                                        Tryk på power-knappen eller sluk for strømmen til routeren.
                                    </p></li>
                                    <li><p>
                                        Vent 1 minut, før du tænder routeren igen.
                                    </p></li>
                                    <li><p>
                                        Giv routeren tid til at starte op.
                                    </p></li>
                                </ul>
                            </li>
                            <li>
                                <p><strong>Tjek at kablerne er koblet rigtigt til</strong></p>
                                <p>
                                    Kablet med gevindstik skal være skruet i routeren og i kabel-tv-stikket på væggen.
                                </p>
                            </li>
                            <li>
                                <p><strong>Lyser din router rigtigt?</strong></p>
                                <ul className="list list--number list--image">
                                    <li><p>
                                        Routeren skal lyse fast grønt i de 4 nederste lamper.
                                        Hvis de ikke lyser fast grønt, skal du nulstille routeren.
                                    </p></li>
                                    <img
                                        className={'max-height no-br'}
                                        src={imageMap.help.equipment.sagemLights}
                                        alt={'Grafik som illustrerer hvordan en Sagem router lyser korrekt.'}
                                    />
                                    <li><p>
                                        Prøv også at skrue kablet med gevindstik ud af routeren og skrue det på igen.
                                    </p></li>
                                </ul>
                            </li>
                            <li>
                                <p><strong>Nulstil din router</strong></p>
                                <ul className="list list--bullet list--image">
                                    <li>
                                        <p>
                                            Tryk en spids genstand mod reset-knappen bag routeren, hvor der står &ldquo;reset&rdquo; i 20 sekunder, mens routeren er tændt.
                                        </p>
                                        <p>
                                            Når du nulstiller routeren, bliver eventuelle ændringer som port forwards mm. også nulstillet.
                                            Det betyder, at du skal lave ændringerne igen, når du har nulstillet.
                                        </p>
                                    </li>
                                    <img
                                        className={'max-height no-br'}
                                        src={imageMap.help.equipment.sagemReset}
                                        alt={'Grafik som illustrerer hvor reset-knappen sidder på en Sagem router.'}
                                    />
                                </ul>
                            </li>
                            <li>
                                <p><strong>Har du aktiveret routeren?</strong></p>
                                <p>
                                    Hvis routeren blinker i telefon-ikonet, skal du aktivere den.
                                    Du finder en guide til at aktivere routeren i velkomstmailen, vi har sendt til dig.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'dsl'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>Internet via telefonstikket</h3>
                        <ul className="list list--bullet">
                            <li>
                                <p><strong>Tjek at kablerne er koblet rigtig til</strong></p>
                                <p>
                                    Det grå telefon/DSL-kabel fra routerens grå DSL-port skal sidde i det firkantede telefon/KAP-stik på væggen.
                                </p>
                            </li>
                            <li>
                                <p><strong>Nulstil din router</strong></p>
                                <ul className="list list--bullet list--image">
                                    <li>
                                        <p>
                                            Tryk en spids genstand mod reset-knappen bag routeren, hvor der står &ldquo;reset&rdquo; i 20 sekunder, mens routeren er tændt.
                                        </p>
                                        <p>
                                            Når du nulstiller routeren, bliver eventuelle ændringer som wifi-kode, -navn mm. også nulstillet.
                                            Det betyder, at du skal lave ændringerne igen, når du har nulstillet.
                                        </p>
                                    </li>
                                    <img
                                        className={'max-height no-br'}
                                        src={imageMap.help.equipment.zyxelReset}
                                        alt="Grafik som illustrerer hvor reset-knappen sidder på en Zyxel router."
                                    />
                                </ul>
                            </li>
                            <li>
                                <p><strong>Hvis du har flere telefonstik i din bolig, kan du prøve at flytte routeren til et andet stik</strong></p>
                                <ul className="list list--number">
                                    <li><p>
                                        Er du ny kunde, så tjek om der er andre telefonstik på adressen.
                                    </p></li>
                                    <li><p>
                                        Vent gerne 5 minutter på hvert stik du prøver, før du frakobler routeren igen.
                                    </p></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h3>{WhatConnectionType.question}</h3>
                        {WhatConnectionType.answer}
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Har du stadig ikke noget internet?</h2>
                        <p>
                            Hvis du har prøvet ovenstående (også på din Hiper-router, hvis du bruger din egen router), og det stadig ikke virker, kan du fejlmelde dit internet i Mit Hiper herunder.
                        </p>
                        <div className={'button-container pb-2'}>
                            <Link className={'button button--montserrat with-icon teal'} to={Routing.Selfcare.Internet}>
                                <span className={'text'}>Opret fejlmelding</span>
                                <Icon component={IconArrow}/>
                            </Link>
                        </div>
                        <p>
                            Ellers sidder vi klar til at hjælpe dig &ndash; vi kan tage et grundigt kig på dit internet og vurdere, hvad vi kan gøre for at hjælpe dig.
                            Du kan finde vores kontaktinformation og åbningstider herunder.
                        </p>
                        <div className={'button-container'}>
                            <Link className={'button button--montserrat with-icon teal'} to={Routing.Contact.Index}>
                                <span className={'text'}>Se kontaktinformation</span>
                                <Icon component={IconArrow}/>
                            </Link>
                        </div>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        category: "internet-og-wifi",
                        article: "forventninger-til-wifi",
                        name: "Hvad kan jeg forvente af mit wifi?"
                    },
                    {
                        category: "internet-og-wifi",
                        article: "placering-af-router",
                        name: "Tips til placering af router"
                    },
                    {
                        category: "internet-og-wifi",
                        article: "skift-navn-og-kode-paa-wifi",
                        name: "Skift navn og kode på wifi"
                    }
                ]}
            />
        </>
    )
}
